import { useMemo } from 'react';
import { endpoints, poster, fetcherGET, posterForm, fetcherSwr, deleter, patcher } from '../utils/axios';
import useSWR, { mutate } from 'swr';


export const addMember = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.settings.addMember}`, args);
    return response;
  } catch (e) {
    console.error('addMember error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const updateMember = async (args = {}) => {
  try {
    const userId = args?.userId;
    const url = userId
      ? `${endpoints.settings.updateMember}/${userId}`
      : `${endpoints.settings.updateMember}`;
    const response = await patcher(url, args);
    return response;
  } catch (e) {
    console.error('updateMember error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const AddCentre = async (args = {}) => {
  try {
    const response = await posterForm(`${endpoints.settings.AddCenter}`, args);
    return response;
  } catch (e) {
    console.error('AddCentre error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const checkLegacyClinic = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.settings.checkLegacyClinic}`, args);
    return response;
  } catch (e) {
    console.error('checkLegacyClinic error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const updateCentre = async (args = {}) => {
  try {
    const response = await patcher(`${endpoints.settings.updateCenter}`, args);
    return response;
  } catch (e) {
    console.error('updateCentre error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const getCentres = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.settings.getCentres}`, args);
    return response;
  } catch (e) {
    console.error('getCentres error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};


export function useGetCentres(args = {}, enabled = true) {
  const key = enabled ? [endpoints.settings.getCentres, { params: args }] : null;
  const { data, error, isLoading, isValidating } = useSWR(key, fetcherSwr);
  const memoizedValue = useMemo(() => ({
    centres: Array.isArray(data?.data) ? data.data : [],
    pagination: data?.pagination || {
      total: 0,
      page: args.page || 1,
      limit: args.limit || 50,
      totalPages: 0,
      totalCenter: 0,
    },
    isLoading,
    error,
    isValidating,
    refetch: mutate
  }), [data, error, isLoading, isValidating, args.page, args.limit]);
  return memoizedValue;
}

export function useGetSpecificCenter(id, args = {}, enabled = true) {
  // Only run if enabled AND id exists
  const key = enabled && id ? [`${endpoints.settings.getSpecificCenter}/${id}`, { params: args }] : null;

  const { data, error, isLoading, isValidating } = useSWR(key, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      center: data?.data || null,
      isLoading,
      error,
      isValidating,
      success: data?.success ?? false,
      message: data?.message || "",
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export const removeCenter = async (args = {}) => {
  try {
    const response = await deleter(`${endpoints.settings.removeCenter}${args.centerId}`, args);
    return response;
  } catch (e) {
    console.error('removeCenter error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};


export function useGetPeople(args = {}) {
  const URL = [endpoints.settings.getPeople, { params: args }];

  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    peoples: data?.data || [],
    pagination: data?.pagination || {
      total: 0,
      page: args.page || 1,
      limit: args.limit || 10,
      totalPages: 0,
    },
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating, args.page, args.limit]);

  return memoizedValue;
}

// export function useGetPeoples(args = {}) {
//   const URL = [endpoints.settings.getPeoples, { params: args }];

//   const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

//   const memoizedValue = useMemo(() => ({
//     peoples: data?.data || [],
//     isLoading,
//     error,
//     isValidating,
//     pagination: data?.pagination,
//   }), [data, error, isLoading, isValidating]);

//   return memoizedValue;
// }
export function useGetPeoples(args = {}) {
  const key = args
    ? `${endpoints.settings.getPeoples}?${new URLSearchParams(args).toString()}`
    : null;

  const { data, error, isLoading, isValidating } =
    useSWR(key, fetcherSwr);

  return {
    peoples: data?.data || [],
    pagination: data?.pagination,
    isLoading,
    isValidating,
    error,
  };
}


export function useGetPeoplesDetails(id, args = {}, enabled = true) {
  const key = enabled && id ? [`${endpoints.settings.getPeopleDetails}/${id}`, { params: args }] : null;

  const { data, error, isLoading, isValidating } = useSWR(key, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    peoplesDetails: data?.data || [],
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating]);

  return memoizedValue;
}





export function useGetWorkspaces(args = {}) {
  const URL = [endpoints.settings.getWorkSpace, { params: args }];
  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    workspaces: data?.data || [],
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating]);


  return memoizedValue;
}


export const changeCentre = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.settings.changeCentre}`, args);
    return response;
  } catch (e) {
    console.error('changeCentre error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const userProfileUpdate = async (args) => {
  try {
    const response = await patcher(`${endpoints.settings.getProfile}`, args);
    return response;
  } catch (e) {
    console.error('userProfileUpdate error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};
// export function useGetUserProfile(args = {}) {
//   const URL = [endpoints.settings.getProfile, { params: args }];

//   const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

//   const memoizedValue = useMemo(
//     () => ({
//       userProfile: data?.data || {},
//       isLoading,
//       error,
//       isValidating,
//       refetch: mutate,
//     }),
//     [data, error, isLoading, isValidating]
//   );

//   return memoizedValue;
// }

export function useGetUserProfile(args = {}) {
  const URL = [endpoints.settings.getProfile, { params: args }];

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    URL,
    fetcherSwr,
    {
      revalidateOnMount: true,
      revalidateOnFocus: false,
    }
  );

  return {
    userProfile: data?.data || {},
    isLoading,
    error,
    isValidating,
    refetch: mutate,
  };
}

export function useGetOrgProfile(args = {}) {
  const URL = [endpoints.organisation.getOrgSettings, { params: args }];

  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    orgProfile: data?.data || [],
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating]);

  return memoizedValue;
}
export const orgProfileUpdate = async (args) => {
  try {
    const response = await posterForm(`${endpoints.organisation.getOrgSettings}`, args, 'PATCH');
    return response;
  } catch (e) {
    console.error('orgProfileUpdate error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const removeMember = async (args = {}) => {
  try {

    const centerIds = args.centerIds.join(',');
    const response = await deleter(`${endpoints.settings.removeMember}?centerIds=${centerIds}&userId=${args.userId}`, args);

    return response;
  } catch (e) {
    console.error('removeMember error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const updateGenralSetting = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.settings.updateGenralSetting}`, args);
    return response;
  } catch (e) {
    console.error('updateGenralSetting error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const getGenralSetting = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.settings.getGenralSetting}`, args);
    return response;
  } catch (e) {
    console.error('getGenralSetting error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const syncSpandanReports = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.migration.syncReports}`, args);
    return response;
  } catch (e) {
    console.error('syncSpandanReports error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const getSubscriptionLogs = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.settings.getSubscriptionLogs}`, args);
    return response;
  } catch (e) {
    console.error('getSubscriptionLogs error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const createTopUpOrder = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.credits.createTopUpOrder}`, args);
    return response;
  } catch (e) {
    console.error('createTopUpOrder error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const verifyTopUpPayment = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.credits.verifyTopUpPayment}`, args);
    return response;
  } catch (e) {
    console.error('verifyTopUpPayment error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const getCreditPurchaseHistory = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.credits.getPurchaseHistory}`, args);
    return response;
  } catch (e) {
    console.error('getCreditPurchaseHistory error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const downloadCreditInvoice = async (orderId) => {
  try {
    const response = await fetcherGET(endpoints.credits.downloadInvoice(orderId));

    if (response?.success) {
      // const link = document.createElement("a");
      window.open(response.data?.url, "_blank");
      link.click();
      link.remove();
    }

    return response;
  } catch (e) {
    console.error('downloadCreditInvoice error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};

export const getItems = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.items.getItems}`, args);
    return response;
  } catch (e) {
    console.error('getItems error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};
export const updataOrgSettings = async (args) => {
  try {
    const response = await posterForm(`${endpoints.organisation.updateOrgProfile}`, args, 'PATCH');
    return response;
  } catch (e) {
    console.error('orgProfileUpdate error:', e);
    var response = {};
    response.status = false;
    response.message = e?.response?.data?.message || e.message;
    return response;
  }
};


/* ===================== GET WEBHOOKS ===================== */



export const getWebhooks = async (args = {}) => {
  try {
    const response = await fetcherGET(
      endpoints.webhook.webhooks,
      args
    );
    return response;
  } catch (e) {
    console.error("getWebhooks error:", e);
    return {
      status: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};




export const createWebhook = async (payload = {}) => {
  try {
    const response = await poster(
      endpoints.webhook.createWebhook,
      payload
    );
    return response;
  } catch (e) {
    console.error("createWebhook error:", e);
    return {
      status: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};


export const updateWebhook = async ({ id, ...payload }) => {
  try {
    const url = endpoints.webhook.updateWebhook.replace(":id", id);

    const response = await patcher(url, payload);
    return response;
  } catch (e) {
    console.error("updateWebhook error:", e);
    return {
      status: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};



export const deleteWebhook = async (id) => {
  try {
    const url = endpoints.webhook.deleteWebhook.replace(":id", id);

    const response = await deleter(url);
    return response;
  } catch (e) {
    console.error("deleteWebhook error:", e);
    return {
      status: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};



export function useGetIndianStates(enabled = true) {
  const key = enabled
    ? ["INDIA_STATES"]
    : null;

  const fetcher = () =>
    poster("https://countriesnow.space/api/v0.1/countries/states", {
      country: "India",
    });

  const { data, error, isLoading } = useSWR(key, fetcher);

  return {
    states: data?.data?.states || [],
    isLoading,
    error,
  };
}

/**
 * Hook: Get Cities by State
 */
export function useGetCitiesByState(state, enabled = true) {
  const key =
    enabled && state
      ? ["STATE_CITIES", state]
      : null;

  const fetcher = () =>
    poster("https://countriesnow.space/api/v0.1/countries/state/cities", {
      country: "India",
      state,
    });

  const { data, error, isLoading } = useSWR(key, fetcher);

  return {
    cities: data?.data || [],
    isLoading,
    error,
  };
}


/* ===================== FTP APIs ===================== */

export const getOrganizationFtpSettings = async () => {
  try {
    const response = await fetcherGET(endpoints.ftp.getOrg);
    return response;
  } catch (e) {
    console.error("getOrganizationFtpSettings error:", e);
    return {
      success: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};

export const getFtpCenters = async (args = {}) => {
  try {
    const response = await fetcherGET(endpoints.ftp.getCenters, {
      params: args,
    });
    return response;
  } catch (e) {
    console.error("getFtpCenters error:", e);
    return {
      success: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};

export const revealFtpPassword = async (apiKey) => {
  try {
    const response = await fetcherGET(endpoints.ftp.reveal(apiKey));
    return response;
  } catch (e) {
    console.error("revealFtpPassword error:", e);
    return {
      success: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};

export const updateFtpSettings = async (apiKey, body = {}) => {
  try {
    const response = await patcher(endpoints.ftp.update(apiKey), body);
    return response;
  } catch (e) {
    console.error("updateFtpSettings error:", e);
    return {
      success: false,
      message: e?.response?.data?.message || e.message,
    };
  }
};
